<template>
  <div class="sort"  @click="toList(data.foodTypeId)">  
    <div class="sort-img">
      <img :src="data.pictureName" alt>
    </div>
    <p class="sort-title">{{data.foodTypeName}}</p>
  </div>
</template>
<script>
export default {
  name: "sort-panel",
  props:['data'],
  methods:{
     toList(foodTypeId){
      console.log("点击啦");
      this.$router.push({
        path: "/eating/list",
        query: {foodTypeId,foodName:''}
      })
    }
  }
  
};
</script>
<style lang="less" >
.sort {
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &-img {
    height: 40px;
    width: 40px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-title {
    font-size: 12px;
    color: #222;
  }
}
</style>

